import { Component } from '@angular/core';
import { iBisBaseComponent } from '@dohu/ibis-common';
import { ProxyService } from '../../../service/proxy.service';
import { PatientDetailsService } from './patient-details.service';

@Component({
    selector: 'app-patient-details',
    templateUrl: './patient-details.component.html',
    styleUrls: ['patient-details.component.scss']
})
export class PatientDetailComponent extends iBisBaseComponent {
    public declare edit: PatientDetailsService;

    constructor(public proxy: ProxyService) {
        super(proxy.patientDetails, proxy.lg, proxy.iui, proxy.activatedRoute);
    }

    public onPINChanged = (ev: any) => {
        if (ev.value) {
            const [bd, age] = this.edit.getBirthday(ev.value);
            this.edit.model.birthDate = bd;
            this.edit.model.age = age;
            this.edit.model.isMinor = age < 14;
            /*   if (!this.edit.model.isMinor) {
                  this.edit.model.bcNo = null;
                  this.edit.model.bcSerial = null;
              } */
            if (this.edit.masc.some(el => el === ev.value[0])) {
                this.edit.model.sex = 1;
            } else if (this.edit.fem.some(el => el === ev.value[0])) {
                this.edit.model.sex = 2;
            }
        }
    }

    public onCountyValueChanged = (ev: any) => {
        if (ev.event) {
            this.edit.countyId = ev.value;
            this.edit.model.localityId = null;
        }
    };

    public onSelectionChanged(ev: any) {
        const toggledItem = ev.addedItems.length ? ev.addedItems[0] : ev.removedItems[0]
        this.edit.model[toggledItem.value] = !this.edit.model[toggledItem.value]
    }

    //TODO: De gasit o forma mai frumoasa de setare
    public onIsForeignerClick = (ev: any) => {
        this.edit.model.isForeigner = !this.edit.model.isForeigner
    }
    public onIsMinorClick = (ev: any) => {
        this.edit.model.isMinor = !this.edit.model.isMinor
    }
    public onMarketingAgreementClick = (ev: any) => {
        this.edit.model.marketingAgreement = !this.edit.model.marketingAgreement
    }
    public onSmsAgreementClick = (ev: any) => {
        this.edit.model.smsAgreement = !this.edit.model.smsAgreement
    }
    public onGdprAgreementClick = (ev: any) => {
        this.edit.model.gdprAgreement = !this.edit.model.gdprAgreement
    }

}
